"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports.labelStyles = exports.iconStyles = exports.endcapStyles = exports.endcapBorderShadow = exports.columnStyles = exports.childrenStyles = exports.aisleStyles = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _css2 = require("@emotion/css");
var _token = require("./../_utils/token");
var _focusRing = _interopRequireDefault(require("./../_styles/focus-ring"));
var _noTextWrap = _interopRequireDefault(require("./../_styles/no-text-wrap"));
var _rtl = require("./../_utils/rtl");
var _borderRadius = _interopRequireDefault(require("./../_utils/border-radius"));
var _reducedMotionStyles = _interopRequireDefault(require("./../_styles/reduced-motion-styles"));
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/* Styles for the root element */
var styles = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var _objectSpread2;
  var cursor = _ref.cursor,
    size = _ref.size,
    fontSize = _ref.fontSize,
    focus = _ref.focus,
    error = _ref.error,
    disabled = _ref.disabled,
    width = _ref.width,
    borderWidthLtr = _ref.borderWidthLtr,
    borderWidthRtl = _ref.borderWidthRtl,
    _ref$borderSides = _ref.borderSides,
    borderSides = _ref$borderSides === void 0 ? [] : _ref$borderSides,
    inputBorderRadius = _ref.inputBorderRadius,
    colorScheme = _ref.colorScheme;
  var state = disabled ? "disabled" : focus ? "focus" : error ? "error" : "default";
  return (0, _css2.css)(_objectSpread(_objectSpread({}, t.typographyCss((0, _token.getTokenKey)("text", fontSize || size))), {}, (_objectSpread2 = {
    color: t("foregroundColor", disabled ? "disabled" : "default"),
    display: "flex",
    boxSizing: "border-box",
    flexDirection: "row",
    justifyContent: "stretch",
    cursor: disabled ? "not-allowed" : cursor,
    backgroundColor: t("backgroundColor", state),
    colorScheme: colorScheme,
    height: t("height", size),
    maxWidth: t("widthMax"),
    width: width,
    outline: "none",
    // If an explicit width is set then don't allow the input to flex
    flex: width ? "none !important" : undefined,
    borderWidth: borderWidthLtr ? borderWidthLtr : t("borderWidth"),
    borderRadius: borderSides.length > 0 ? (0, _borderRadius["default"])(inputBorderRadius, borderSides) : t("borderRadius")
  }, (0, _defineProperty2["default"])(_objectSpread2, "[dir=\"rtl\"] &", {
    borderRadius: borderSides.length > 0 ? (0, _borderRadius["default"])(inputBorderRadius, borderSides.map(function (borderSide) {
      return (0, _rtl.getRtl)(borderSide);
    })) : t("borderRadius"),
    borderWidth: borderWidthRtl ? borderWidthRtl : t("borderWidth")
  }), (0, _defineProperty2["default"])(_objectSpread2, "borderColor", t("borderColor", state)), (0, _defineProperty2["default"])(_objectSpread2, "borderStyle", "solid"), _objectSpread2)), !disabled ? (0, _focusRing["default"])(t.tokens, {
    focus: focus,
    error: error,
    offset: 1,
    dropShadow: true,
    borderWidth: t("focusRingBorderWidth"),
    borderRadius: inputBorderRadius ? inputBorderRadius + 1 : t("borderRadius"),
    borderSides: borderSides
  }) : undefined);
}, ["cursor", "size", "fontSize", "focus", "error", "disabled", "width", "borderWidthLtr", "borderWidthRtl", "borderSides", "inputBorderRadius", "colorScheme"]);

/* Styles for each segment of the input (e.g. an endcap, an icon, the input
container) */
exports.styles = styles;
var columnStyles = (0, _token.memoizeTokenStyles)(function (t, _ref2) {
  var size = _ref2.size,
    label = _ref2.label;
  var horizontalPadding = t("spacingInsetHorizontal");
  var verticalPadding = t("spacingInsetVertical", size);
  // If we have a label then reduce the top padding until the label is the same
  // number of pixels from the top as the original top padding when it's floated
  // down over the input
  var topPadding = label && verticalPadding > 0 ? verticalPadding - t("labelFloatDistance", size) : verticalPadding;
  return (0, _css2.css)({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    padding: "".concat(topPadding, "px ").concat(horizontalPadding, "px ").concat(verticalPadding, "px ").concat(horizontalPadding, "px")
  });
}, ["size", "label"]);
exports.columnStyles = columnStyles;
var endcapBorderShadow = function endcapBorderShadow(t, _ref3) {
  var state = _ref3.state,
    side = _ref3.side;
  return side === "left" ? " 1px 0 0 0 ".concat(t("borderColor", state)) : "-1px 0 0 0 ".concat(t("borderColor", state));
};

/* Styles for the prefix/suffix caps on either end of the input */
exports.endcapBorderShadow = endcapBorderShadow;
var endcapStyles = (0, _token.memoizeTokenStyles)(function (t, _ref4) {
  var disabled = _ref4.disabled,
    side = _ref4.side,
    size = _ref4.size,
    label = _ref4.label;
  var state = disabled ? "disabled" : "default";
  return (0, _css2.css)(columnStyles(t, {
    size: size,
    label: label
  }), (0, _defineProperty2["default"])({
    flexShrink: 0,
    backgroundColor: t("endcapBackgroundColor", state),
    color: t("endcapForegroundColor", state),
    borderRadius: (0, _borderRadius["default"])(t("endcapBorderRadius"), side === "left" ? ["topLeft", "bottomLeft"] : ["topRight", "bottomRight"]),
    boxShadow: endcapBorderShadow(t, {
      state: state,
      side: side
    })
  }, "[dir=\"rtl\"] &", {
    borderRadius: (0, _borderRadius["default"])(t("endcapBorderRadius"), side === "left" ? ["topRight", "bottomRight"] : ["topLeft", "bottomLeft"]),
    boxShadow: endcapBorderShadow(t, {
      state: state,
      side: (0, _rtl.getRtl)(side)
    })
  }), _noTextWrap["default"]);
}, ["disabled", "side", "size", "label"]);

/* Styles for everything in-between the endcaps */
// since the aislestyle and columnstyle shares the same attributes
// we can memoize them together
exports.endcapStyles = endcapStyles;
var aisleStyles = (0, _token.memoizeTokenStyles)(function (t, _ref5) {
  var size = _ref5.size,
    label = _ref5.label;
  return (0, _css2.css)(columnStyles(t, {
    size: size,
    label: label
  }), {
    flex: "auto",
    overflow: "hidden"
  });
}, ["size", "label"]);
exports.aisleStyles = aisleStyles;
var labelStyles = (0, _token.memoizeTokenStyles)(function (t, _ref6) {
  var _objectSpread3;
  var animated = _ref6.animated,
    focus = _ref6.focus,
    disabled = _ref6.disabled,
    floated = _ref6.floated,
    size = _ref6.size;
  var colorState = disabled ? "disabled" : focus ? "focus" : "default";
  return (0, _css2.css)(_objectSpread(_objectSpread({
    display: "block",
    cursor: "inherit",
    color: t("labelColor", colorState)
  }, t.typographyCss("labelDefault")), {}, (_objectSpread3 = {
    marginTop: t("spacingVertical"),
    marginBottom: t("spacingVertical"),
    transformOrigin: "top left"
  }, (0, _defineProperty2["default"])(_objectSpread3, "[dir=\"rtl\"] &", {
    transformOrigin: "top right"
  }), (0, _defineProperty2["default"])(_objectSpread3, "transform", floated ? "translateY(0px) scale(".concat(t("labelFloatedFontSize") / t("labelDefaultFontSize"), ")") : "translateY(".concat(t("labelFloatDistance", size), "px) scale(1)")), (0, _defineProperty2["default"])(_objectSpread3, "transition", animated ? t.transitionCss("labelMotion", ["color", "transform"]) : undefined), _objectSpread3), _reducedMotionStyles["default"]), _noTextWrap["default"]);
}, ["animated", "focus", "disabled", "floated", "size"]);
exports.labelStyles = labelStyles;
var iconStyles = (0, _token.memoizeTokenStyles)(function (t, _ref7) {
  var disabled = _ref7.disabled,
    position = _ref7.position;
  var state = disabled ? "disabled" : "default";
  return (0, _css2.css)({
    display: "flex",
    alignItems: "center",
    marginInlineStart: position === "prefix" ? t("spacingInsetHorizontal") : 0,
    marginInlineEnd: position == "prefix" ? 0 : t("spacingInsetHorizontal"),
    color: t("foregroundColor", state)
  });
}, ["disabled", "position"]);
exports.iconStyles = iconStyles;
var childrenStyles = (0, _token.memoizeTokenStyles)(function (t, _ref8) {
  var size = _ref8.size,
    fontSize = _ref8.fontSize,
    disabled = _ref8.disabled,
    empty = _ref8.empty,
    label = _ref8.label,
    floated = _ref8.floated;
  var state = disabled ? "disabled" : "default";
  return (0, _css2.css)(_objectSpread(_objectSpread({
    position: "relative",
    color: empty ? t("placeholderColor", state) : undefined
  }, t.typographyCss((0, _token.getTokenKey)("text", fontSize || size))), {}, {
    minHeight: t((0, _token.getTokenKey)("text", fontSize || size), "lineHeight"),
    opacity: label && !floated ? 0 : 1,
    pointerEvents: disabled ? "none" : undefined
  }));
}, ["size", "fontSize", "disabled", "empty", "label", "floated"]);
exports.childrenStyles = childrenStyles;